import React from "react";
import { useNavigate } from "react-router-dom";



export default function GardenDailyWorkCard({ count, title, navLink, cardName, imgPath, DailyPreventiveWorkNavigate }) {
    const navigate = useNavigate()

    const handleGardenDailyWorkCard = () => {
        navigate(navLink)
    }
    return (
        <div style={{ cursor: 'pointer' }} className=" mb-1 p-3 shadow blue_borders bg-white  daily-card-width" onClick={() => DailyPreventiveWorkNavigate(title)}>
            <div className="row" >

                <div className="col-lg-6">
                    <h4>{count}</h4>
                    <h6 className="text-black"><b>{title}</b></h6>
                </div>

                <div className="col-lg-6  d-flex  align-items-center justify-content-center" >
                    <img className={cardName} style={{ height: '100%' }} src={imgPath} alt="" />
                </div>

            </div>
        </div>
    )
}